import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// app
import { multipartAdminAxios } from '../../admin.api';
import { THIRD_PARTY_OFFICE_LIST, OPERATIONAL_THIRD_PARTY } from '../../queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useEditOperationalThirdParty = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const handleSettled = (data) => {
    dispatch(hideModal());
  };
  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useEditOperationalThirdParty',
      message: 'Data missing for PUT request',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    dispatch(enqueueNotification('notification.admin.parentClientPatchFail', 'error'));
    dispatch(hideModal());
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_THIRD_PARTY);
    queryClient.invalidateQueries(THIRD_PARTY_OFFICE_LIST);

    dispatch(
      enqueueNotification('notification.admin.parentClientPatchSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
    dispatch(hideModal());
  };

  return useMutation(
    async (requestData) => {
      const { newData, id } = requestData;

      if (!utils.generic.isValidObject(newData)) {
        throw new Error('Invalid operational client request body');
      }

      let form = new FormData();
      form.append('id', id);
      form.append('name', newData.name);

      if (!isEmpty(newData?.logo)) {
        newData.logo.forEach((file) => form.append('logo', file));
      }

      return await multipartAdminAxios.patch(`v1/operational-third-party/${id}`, form);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
